<template>
  <div>
    <v-text-field
      v-validate="validator"
      outlined
      label="Complemento"
      :value="value"
      :error-messages="errors.first(field)"
      :name="field"
      v-bind="config"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    value: String,
    field: String,
    config: Object,
    validator: Object
  }
}
</script>

<style></style>
